/** Lets SignalR push notifications without importing React context. */
let notificationHandler = null;

export const registerNotificationHandler = (handler) => {
  notificationHandler = typeof handler === "function" ? handler : null;
};

export const pushNotification = (payload) => {
  notificationHandler?.(payload);
};
